import React, { useState } from 'react'
import { usePermissions } from '../../../../../../common/hooks/usePermissions'
import {
  ConfirmDialog,
  ConfirmDialogValue,
} from '../../../../../../common/components'
import { TreatmentStatus } from '../../../../../../models/graphqlTypes'
import { useTreatmentSend } from '../../../hooks/useTreatmentSend'
import { useStoreActions } from '../../../../../../store/store.hooks'
import { useTranslation } from '../../../../../../common/hooks/helper/useTranslation'
import { Button } from '@mui/material'
import { Loading } from '../../../../../../common/components/Loading'
import { useTreatmentPanelData } from '../TreatmentPanelProvider'

export const SendTreatmentButton: React.FC = () => {
  const { treatment } = useTreatmentPanelData()
  const { t } = useTranslation()
  const { isOwnTreatment } = usePermissions(treatment?.doctor.id)
  const setToast = useStoreActions((actions) => actions.toast.setToast)

  const [sendTreatmentOpen, setSendTreatmentOpen] =
    useState<ConfirmDialogValue>(false)

  const isDraft = treatment?.status === TreatmentStatus.Draft

  const [sendTreatment, { loading: loadingSendTreatment }] = useTreatmentSend({
    onCompleted: () => {
      setToast({
        text: t('messages:notification.sendTreatment.success'),
        type: 'success',
      })
    },
  })

  const sendTreatmentToPatient = () =>
    sendTreatment({
      variables: {
        treatmentId: treatment.id,
      },
      refetchQueries: ['getTreatment'],
    })

  return (
    <>
      {isOwnTreatment && isDraft && (
        <Button
          sx={{ paddingX: 2, minWidth: 'fit-content' }}
          size="small"
          disabled={!(treatment.appointments ?? []).length}
          startIcon={loadingSendTreatment && <Loading inline size={12} />}
          onClick={() => setSendTreatmentOpen(true)}
          data-cy="TreatmentPanelHeader-Button-sendTreatment"
        >
          {t('treatment:doctor.sendTreatment')}
        </Button>
      )}

      <ConfirmDialog
        valueState={[sendTreatmentOpen, setSendTreatmentOpen]}
        title={t(`treatment:doctor.sendDialogTitle`)}
        text={t(`treatment:doctor.sendDialogText`)}
        onAccept={sendTreatmentToPatient}
        onCancel={() => setSendTreatmentOpen(false)}
      />
    </>
  )
}
